const host = window.location.host;
const parts = host.split(".");
// サブドメインの「-」を「_」に変換し、大文字化して環境変数キーを組み立てる
const loginTypeKey = "VITE_AWS_LOGIN_TYPE_" + parts[0].replace(/-/g, "_").toUpperCase();
const loginTypeValue =
    import.meta.env[loginTypeKey] || import.meta.env.VITE_AWS_LOGIN_TYPE_DEFAULT;
export const isLoginTypeEmail = loginTypeValue === "email";
const usernameOrEmailLabel = isLoginTypeEmail
      ? "ユーザー名 * または メールアドレス *"
      : "ユーザー名 *";
// プレースホルダー用（空白）
const usernameOrEmailPlaceholder = ' ';
const usernameOrEmailMessage = isLoginTypeEmail
    ? "ユーザー名/メールアドレス"
    : "ユーザー名";

export const phrases = {
    ja: {
        'Username': usernameOrEmailLabel,
        'Enter your username': usernameOrEmailLabel,
        'Enter your Username': usernameOrEmailLabel,
        'Password *': 'パスワード *',
        'Confirmation Code': '認証コード(メールをご確認ください)',
        'New Password': '新しいパスワード',
        'Confirm New Password': '新しいパスワード(確認)',
        'An account with the given email already exists.':
        '入力されたメールアドレスのアカウントが既に存在します',
        'Code': '認証コード',
        'Code *': '認証コード *',
        'Enter your code': '認証コードを入力',
        'Confirm a Code': 'コードを確認',
        'Confirm Sign In': 'サインインする',
        'Create account': 'アカウントを作る ',
        'Enter your password': 'パスワードを入力 ',
        'Enter your Password': 'パスワードを入力',
        'Please confirm your Password': 'パスワードを入力',
        'Forgot Password': 'パスワードをお忘れの場合 ',
        'Have an account? ': 'アカウントを持っていますか？',
        'Incorrect username or password': usernameOrEmailMessage + 'かパスワードが異なります ',
        'Incorrect username or password.': usernameOrEmailMessage + 'かパスワードが異なります ',
        'Invalid password format': 'パスワードの形式が無効です ',
        'Invalid phone number format':
        '不正な電話番号の形式です。\n+12345678900 の形式で入力してください',
        'It may take a minute to arrive.':
        'コードを受信するまで数分かかる場合があります。',
        'Lost your code? ': 'コードを失くしましたか？',
        'No account? ': 'アカウントが無いとき ',
        'Password attempts exceeded': 'サインインの試行回数が上限に達しました',
        'Reset password': 'パスワードをリセットする ',
        'Reset Password': 'パスワードのリセット',
        'Sign Out': 'ログアウト ',
        'Sign In': 'ログイン ',
        'Sign in': 'ログイン',
        'Sign Up': '登録 ',
        'Back to Sign In': 'ログイン画面に戻る ',
        'User already exists': '既にユーザーが存在しています ',
        'User does not exist': 'ユーザーが存在しません ',
        'Username cannot be empty': usernameOrEmailMessage + 'は入力必須です',
        'Send code': '認証コードを送信',
        'Send Code': '認証コードを送信',
        'Resend Code': '認証コードを再送信',
        'We Emailed You': 'コードを送信しました',
        'Your code is on the way. To log in, enter the code we emailed to':
        'ログインするには、メールに記載されたコードを入力してください。送信先:',
        'Your code is on the way. To log in, enter the code we texted to':
        'ログインするには、テキストメッセージに記載されたコードを入力してください。送信先:',
        'Password must have at least 8 characters': 'パスワードは8文字以上である必要があります',
        'Your passwords must match': 'パスワードが一致する必要があります',
        'Invalid verification code provided, please try again.':
        '認証コードが誤っています。正しい認証コードを入力し再度お試し下さい。',
        'Password does not conform to policy: Password must have numeric characters': 'パスワードには少なくとも1つの数字を含める必要があります',
        'Password does not conform to policy: Password must have symbol characters': 'パスワードには少なくとも1つの記号を含める必要があります',
        'Password does not conform to policy: Password must have lowercase characters': 'パスワードには少なくとも1つの小文字を含める必要があります',
        'Password does not conform to policy: Password must have uppercase characters': 'パスワードには少なくとも1つの大文字を含める必要があります',
        'Attempt limit exceeded, please try after some time.': '試行回数の上限を超えました。しばらくしてから再度お試しください',
        'A network error has occurred.': 'ネットワークエラーが発生しました',
        'Cannot reset password for the user as there is no registered/verified email or phone_number':
        '登録済みまたは確認済みの' + usernameOrEmailMessage + 'ではないため、パスワードをリセットできません',
    },
};
